// Small display helpers used by the wizard preview and the brochure.

export function formatDateRange(startISO, endISO) {
  if (!startISO) return "";
  const start = new Date(startISO);
  const opts = { month: "long", day: "numeric", year: "numeric" };
  if (!endISO || startISO === endISO) {
    return start.toLocaleDateString(undefined, opts);
  }
  const end = new Date(endISO);
  const sameMonth =
    start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
  if (sameMonth) {
    const m = start.toLocaleDateString(undefined, { month: "long" });
    return `${m} ${start.getDate()}–${end.getDate()}, ${end.getFullYear()}`;
  }
  return `${start.toLocaleDateString(undefined, opts)} – ${end.toLocaleDateString(undefined, opts)}`;
}

export function formatLocation(details = {}) {
  return [details.venue, details.city, details.country].filter(Boolean).join(", ");
}
